<template lang="pug">
  div
    h3.title 申請書情報

    section.section
      .columns
        // PDF出力用（画面には表示しない）
        .column.is-half#app-id
          b-field(label="申請書ID")
            p XXX-YYYYMMDD-HHIISS-123456
        .column.is-half
          b-field.required(
            label="作成日",
            :message="getInputMessage('application.order_date')",
            :type="getInputType('application.order_date')"
          )
            b-datepicker(
              v-if="$parent.$parent.isEdit",
              v-model="order_date",
              name="application.order_date",
              required,
              :month-names="monthNames",
              :day-names="dayNames",
              :date-formatter="Util.dateToString"
              editable,
              v-validate="",
              data-vv-as="作成日",
              data-testid="application.order_date"
            )
              b-button.is-primary(@click='order_date = new Date()')
                b-icon(icon='calendar-day')
                span Today
              |
              |
              //-button.button.is-light(@click='value.order_date = null')
                b-icon(icon='times')
                span Clear
            p(v-else, data-testid="application.order_date") {{Util.dateToString(value.order_date) || '(未入力)'}}

      .columns
        .column.is-half(v-show="Util.isIncludes(showFields, 'order_no')")
          b-field(
            label="ご注文番号",
            :class="{required: Util.isIncludes(requiredFields, 'order_no')}",
            :message="getInputMessage('application.order_no')",
            :type="getInputType('application.order_no')"
          )
            b-input(
              v-if="$parent.$parent.isEdit",
              v-model="value.order_no",
              name="application.order_no",
              :required="Util.isIncludes(requiredFields, 'order_no')",
              :maxlength="maxlen_app.order_no",
              v-validate="",
              data-vv-as="ご注文番号",
              data-testid="application.order_no"
            )
            p(v-else, data-testid="application.order_no") {{value.order_no || '(未入力)'}}

        .column.is-half(v-show="Util.isIncludes(showFields, 'estimate_no')")
          b-field(
            label="お見積り番号",
            :class="{required: Util.isIncludes(requiredFields, 'estimate_no')}",
            :message="getInputMessage('application.estimate_no')",
            :type="getInputType('application.estimate_no')"
          )
            b-input(
              v-if="$parent.$parent.isEdit",
              v-model="value.estimate_no",
              name="application.estimate_no",
              :required="Util.isIncludes(requiredFields, 'estimate_no')",
              :maxlength="maxlen_app.estimate_no",
              v-validate="",
              data-vv-as="お見積り番号",
              data-testid="application.estimate_no"
            )
            p(v-else, data-testid="application.estimate_no") {{value.estimate_no || '(未入力)'}}

      b-field(
        label="備考"
        :message="getInputMessage('application.notes')",
        :type="getInputType('application.notes')"
      )
        b-input(
          v-if="$parent.$parent.isEdit",
          type="textarea",
          v-model="value.notes",
          name="application.notes",
          :maxlength="maxlen_app.notes",
          v-validate="",
          data-vv-as="備考",
          data-testid="application.notes"
        )
        p.text-prewrap(v-else, data-testid="application.notes") {{value.notes || '(未入力)'}}

      app-message.nopdf(v-if="Util.isIncludes(requiredFields, 'order_no')" type="info")
        p ※ ネオジャパンへ発注されるパートナー様のご注文番号を記載ください。
</template>

<script>
import MixinHandleErrors from '@/mixins/handleErrors'
import { Applications as maxlen_app } from '@/config/maxlengths'
import Util from '@/utils/util'
import AppMessage from '@/components/AppMessage'

export default {
  name: 'FormHeader',
  mixins: [ MixinHandleErrors ],
  components: { AppMessage },
  props: {
    value: {type: Object, required: false, default () { return {} }},
    showFields: {type: Array, required: false, default () { return ['order_date', 'order_no', 'estimate_no', 'notes'] }},
    requiredFields: {
      type: Array,
      required: false,
      default () {
        if (this.$parent.$parent.isPartnerApp()) {
          return ['order_date', 'order_no']
        } else {
          return ['order_date', 'estimate_no']
        }
      }
    },
  },
  watch: {
    // 作成日
    order_date: function (newDate) {
      this.value.order_date = newDate
    }
  },
  data () {
    return {
      Util,
      maxlen_app,
      activeTab: 0,
      monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      dayNames: ['日', '月', '火', '水', '木', '金', '土'],
      order_date: new Date()
    }
  }
}
</script>

<style scoped>
#app-id {
  display: none;
}
.is-pdf #app-id {
  display: block;
}
.text-prewrap {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/com/FormHeader.vue